import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const roleBadgeColors = {
  platform_admin: "bg-indigo-100 text-indigo-700",
  tenant_admin: "bg-emerald-100 text-emerald-700",
  support_agent: "bg-amber-100 text-amber-700",
  viewer: "bg-slate-100 text-slate-600",
};

const Topbar = ({ title, subtitle }) => {
  const { user } = useAuth();
  const role = user?.role || "viewer";
  const badgeColor = roleBadgeColors[role] || roleBadgeColors.viewer;

  return (
    <div className="flex flex-col gap-3 border-b border-slate-200 bg-white px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <div>
          <h2 className="text-lg font-semibold text-slate-950">{title}</h2>
          {subtitle ? <p className="text-sm text-slate-500">{subtitle}</p> : null}
        </div>
        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${badgeColor}`}>
          {role.replace(/_/g, " ")}
        </span>
      </div>
      <Link to="/home" className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
        Back to site
      </Link>
    </div>
  );
};

export default Topbar;
